<template>
  <div class="contents">
    <div class="zyk-search-wrapper-box">
      <div class="zyk-search-wrapper">
        <div class="zyk-search-con">
          <h2>批次线查询</h2>
        </div>
      </div>
    </div>

    <div class="list">
      <el-form :model="query" inline>
          <el-form-item label="省份">
            <el-select v-model="query.province" placeholder="请选择" size="small" clearable>
              <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年份" label-width="100px" clearable>
            <el-input style="width: 192px;" v-model="query.year" placeholder="请输入年份" size="small"></el-input>
          </el-form-item>
          <el-form-item label-width="100px">
            <el-button type="success" size="small" icon="el-icon-search" @click="handleSearch"
              style="margin: 0px 2px;">查询</el-button>
          </el-form-item>
        </el-form>
      </el-form>
      <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}" v-loading="loading">
        <el-table-column prop="province" label="省份" align="center">
        </el-table-column>
        <el-table-column prop="year" label="年份" align="center">
        </el-table-column>
        <el-table-column prop="group_d" label="组别" align="center">
        </el-table-column>
        <el-table-column prop="strong_basi" label="强基线(原一本)" align="center">
        </el-table-column>
        <el-table-column prop="undergraduate_line" label="本科线" align="center">
        </el-table-column>
        <el-table-column prop="specialist_line" label="专科线" align="center">
        </el-table-column>
      </el-table>
      
      <div style="width: 100%;margin-top: 20px;margin-bottom:20px;display: flex;align-items: center;justify-content: center;">
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="query.page"
              :page-sizes="[20,50,100,120]"
              :page-size="query.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex"
  import cityJson from "@/utils/city.json"
  import {
    OmitData_index
  } from "@/api/gw/major.js"
  export default {
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
        loading: false,
        list: [],
        total: 0,
        query: {
          page: 1,
          limit: 20,
          province: "",
          year: ""
        },
        cityData: cityJson
      }
    },
    mounted(){
      this.getList();
      if (localStorage.getItem("qichengUserToken")) {
        this.$store.dispatch("getUserInfo");
      }
    },
    methods: {
      getList() {
        this.loading = true
        OmitData_index(this.query).then(res => {
          this.total = res.data.total
          this.list = res.data.data
        }).finally(() => {
          this.loading = false
        })
      },
      handleSearch() {
        this.query.page = 1
        this.getList();
      },
      handleSizeChange(val) {
        this.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list {
    width: 1250px;
    margin: 0 auto;
    padding-top: 30px;
  }

  .zyk-search-wrapper-box {
    background: linear-gradient(180deg, #49c48d, #1cb278);

    .zyk-search-wrapper {
      height: 200px;
      background: url(../../assets/banner-zyk-pc.png) no-repeat top;
      text-align: center;

      .zyk-search-con {
        width: 520px;
        padding-top: 36px;
        margin: 0 auto;

        h2 {
          height: 53px;
          font-size: 38px;
          font-weight: 600;
          color: #fff;
          line-height: 53px;
          text-shadow: 0 2px 2px rgba(0, 0, 0, .06);
          margin-bottom: 20px;
          letter-spacing: 2px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/OmitData/index.vue